import React from 'react';
import * as Notifications from 'react-notification-system-redux';
import { compose } from 'recompose';

import { createStyles, Grid, withStyles, WithStyles } from '@material-ui/core';

import { appRedirectConfig, appRoutesConfig } from './appRoutesConfig';
import { Loading } from '@components/Loading';
import { RouterOutlet } from '@components/RouterOutlet';
import LoginPage from './Login';
import { NavBar } from '@components/NavBar';
import { permittedRoutes } from '@utils/permissionUtils';
import { User } from '@api/types.generated';

export interface AppProps {
  user: User;
  notifications: any;
  isLogged: boolean;
  isLoading: boolean;
  match: any;
}

interface AppPrivateProps extends AppProps, WithStyles {}

const styles = () =>
  createStyles({
    '@global': {
      '*': {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
      },
      body: {
        backgroundColor: '#f5f8fa',
        height: '100%',
      },
      a: {
        textDecoration: 'none',
      },
      html: {
        height: '100%',
        width: '100%',
        font: 'inherit',
      },
    },
    root: {
      display: 'flex',
      justifyContent: 'center',
    },
    appContainer: {
      flexDirection: 'column',
      maxWidth: 800,
      width: '100%',
    },
    loginContainer: {
      height: '100%',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
    },
  });

const App: React.FunctionComponent<AppPrivateProps> = (props) => {
  const { classes, notifications, user, isLoading, isLogged } = props;

  const appContent = isLogged ? (
    <Grid container className={classes.root}>
      <Grid item className={classes.appContainer}>
        <NavBar />
        <RouterOutlet routes={permittedRoutes(appRoutesConfig, user)} redirect={appRedirectConfig} />
      </Grid>
    </Grid>
  ) : (
    <Grid container className={classes.loginContainer}>
      <Grid item>
        <LoginPage />
      </Grid>
    </Grid>
  );

  return (
    <>
      <Notifications notifications={notifications} />
      <Loading isLoading={isLoading}>{appContent}</Loading>
    </>
  );
};

export default compose<AppPrivateProps, AppProps>(withStyles(styles))(App);
